export default {"src":"/_next/static/media/Alert.a1ca08f0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};